export default __webpack_public_path__ + "static/media/explore_destination_img1.30b7e6c1.jpg";